export default "__VITE_ASSET__Dk6zgz2I__"